import requestv2 from "~/utils/http-v2";

const customerApi = {
	get : async (id) => {
		const url = `v2/customer/detail/${id}`;
		return await requestv2.get(url);
	},
	gets : async (params) => {
		const url = 'v2/customer';
		return await requestv2.get(url, {params});
	},
	getByContract : async (id) => {
		const url = `v2/customer/contract/${id}`;
		return await requestv2.get(url);
	},
	add : async (params) => {
		const url = 'v2/customer';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/customer/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/customer/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/customer/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	transfer : async (params) => {
		const url = `v2/customer/transfer/${params.id}`;
		return await requestv2.post(url, params);
	},
	editGroup : async (params) => {
		const url = `v2/customer/groups/${params.id}`;
		return await requestv2.post(url, params);
	},
	resendPass : async (id) => {
		const url = `v2/customer/resend-pass/${id}`;
		return await requestv2.post(url);
	},
};

export default customerApi;